const STORIES_URL = 'cdn/stories/';

export const RESOURCES = {
  STORIES: STORIES_URL,
  REVIEWS: `${STORIES_URL}tools/_reviews_/`,
  ARTICLES: `${STORIES_URL}?filter_query[type][in]=Article`
};
